module.exports = __webpack_public_path__ + "img/Group 33591.0ed8d6f3.png";